<div class="drop-zone portal-absolute-fill"
     [class.drop-box]="isDragging"
     [class.dragover]="droppable && (isDragOver || isDragOverChild)"
     [class.invalid-drop]="!droppable && (isDragOver || isDragOverChild)"
     #dropzone>
</div>